import { render } from "./ModalAddUpdateThreshold.vue?vue&type=template&id=4258ed83"
import script from "./ModalAddUpdateThreshold.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateThreshold.vue?vue&type=script&lang=js"

import "./ModalAddUpdateThreshold.vue?vue&type=style&index=0&id=4258ed83&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__